module.exports = __webpack_public_path__ + "4a139ba4136f4636c1c8589d60fa5c5b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/game-owl.png
// module id = 2035
// module chunks = 0